export default __webpack_public_path__ + "static/media/sixtyPercentageThreshold.280b8dd0.svg";